import { Input } from "../../input/input";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EmailQuestionProps } from "../types";

export const EmailQuestion = (props: EmailQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    disabled,
    answerAriaLabel,
    changeEventHandler,
    answerProps,
    contentClassName,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    answerDataTestId
  } = props;
  const headerFooterProps = {
    gap,
    required,
    invalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          className={contentClassName}
          type="email"
          value={answer}
          placeholder={placeholder}
          onChange={changeEventHandler}
          maxLength={maxLength}
          disabled={disabled}
          aria-label={answerAriaLabel}
          {...answerProps}
          size={size}
          data-testid={answerDataTestId}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
